export default __webpack_public_path__ + "images/KW.27b6cba.png";